// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./blocks/shortcode/style.scss
// module id = 55
// module chunks = 0